


import Swal from 'sweetalert2';
import firebase from '../config/global-variables';

const getPositions = async(userID,searctxt)=> {
    try {
        const url = `https://us-central1-${firebase.nameProyectFirebase}.cloudfunctions.net/app/api/getOperatorsLastPosition`;
        const optionsRequest = {
            method:'POST',
            headers:{"Content-Type":"application/json","Access-Control-Allow-Origin": "*"},
            body:JSON.stringify({
               managerID:userID,
               searchText:searctxt
            }),
           // mode:'no-cors'
        };
        console.log("managerID:" + userID);
        console.log("searchText:" + searctxt);
        const response = 
        await fetch(url,optionsRequest);
       const data = await response.json();
       const parseData = JSON.parse(data)
        const {Data} = parseData;
        console.log('Positions =>',Data);
        return Data;
    } catch (error) {

        const mensaje = String(error);
        if (mensaje.trim().toUpperCase() === 'TYPEERROR: FAILED TO FETCH') {
          Swal.fire({
            title: "Advertencia",
            text: "Se ha perdido la conexión",
            icon: "warning",
          });
        } else {
        Swal.fire({
            title:'Error',
            text:'No se pudo conectar al servidor de Firebase, intentelo mas tarde.',
            icon:'error',
            confirmButtonText:'Ok',
        });
        }

        return [];
        
    }
}

export{getPositions}